/**
 * Supabase client for Cleic Lens frontend (auth-only, used by the auth gate).
 *
 * The same Cleic Supabase project also backs cleic.com (front door) + Cleic
 * Ledger. A session obtained on cleic.com is handed off to this app via URL
 * hash on first navigation — see `auth-gate.js` for the consume + restore
 * mechanics.
 *
 * Lens has no backend of its own — it reads from Ledger's API
 * (`/api/ledger.json` per F-022 sibling pattern) or falls back to the
 * snapshot fixture in `/public/ledger.json`. The session token does not
 * affect snapshot rendering; it only matters once the Ledger API is
 * reachable + JWT-validated (post-Phase-C2).
 */
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.error(
    '[cleic-lens] VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY missing — auth gate cannot function. Set both in Vercel env vars (Cleic Supabase project) + redeploy.',
  );
}

export const supabase = createClient(
  supabaseUrl ?? 'https://placeholder.supabase.co',
  supabaseAnonKey ?? 'placeholder-anon-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      // We parse the cleic-handoff hash manually in auth-gate.js so we can
      // strip the tokens from the URL before any other code sees them.
      detectSessionInUrl: false,
    },
  },
);
